import { axiosNew } from './axiosService';

const baseURL = 'chat';

export class ChatService {
	// Toasters are suppressed because failures are rendered inside the thread.
	// Uses the shared instance directly: `axiosPost` takes no abort signal.
	sendMessage({ message, conversationId }, signal) {
		return axiosNew.post(
			baseURL,
			{ message, conversationId },
			{
				headers: { hide_success_toaster: 'true', hide_toaster: 'true' },
				signal: signal,
			}
		);
	}

	// Returns the workbook as a blob; failures are surfaced on the report card.
	exportReport(reportId) {
		return axiosNew.get(`${baseURL}/reports/${reportId}/export`, {
			responseType: 'blob',
			headers: { hide_success_toaster: 'true', hide_toaster: 'true' },
		});
	}
}
